import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../_metronic/helpers'
import {FileArea, FileAreasQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const GET_FILEAREA_URL = `${API_URL}/filearea/getfilearea`
const CREATE_FILEAREA_URL = `${API_URL}/filearea/addfilearea`
const UPDATE_FILEAREA_URL = `${API_URL}/filearea/updatefilearea`
const DELETE_FILEAREA_URL = `${API_URL}/filearea/deletefilearea`
const GET_FILEAREAS_URL = `${API_URL}/filearea/getfileareas`

const getFileAreas = (query: string): Promise<FileAreasQueryResponse> => {
  return axios
    .get(`${GET_FILEAREAS_URL}?${query}`)
    .then((d: AxiosResponse<FileAreasQueryResponse>) => d.data)
}

const getFileAreaById = (id: ID): Promise<FileArea | undefined> => {
  return axios
    .get(`${GET_FILEAREA_URL}/${id}`)
    .then((response: AxiosResponse<Response<FileArea>>) => response.data)
    .then((response: Response<FileArea>) => response.data)
}

const createFileArea = (filearea: FileArea): Promise<FileArea | undefined> => {
  return axios
    .post(CREATE_FILEAREA_URL, filearea)
    .then((response: AxiosResponse<Response<FileArea>>) => response.data)
    .then((response: Response<FileArea>) => response.data)
}

const updateFileArea = (filearea: FileArea): Promise<FileArea | undefined> => {
  return axios
    .put(`${UPDATE_FILEAREA_URL}/${filearea.id}`, filearea)
    .then((response: AxiosResponse<Response<FileArea>>) => response.data)
    .then((response: Response<FileArea>) => response.data)
}

const deleteFileArea = (fileareaId: ID): Promise<void> => {
  return axios.delete(`${DELETE_FILEAREA_URL}/${fileareaId}`).then(() => {})
}

const deleteSelectedFileAreas = (fileareaIds: Array<ID>): Promise<void> => {
  const requests = fileareaIds.map((id) => axios.delete(`${DELETE_FILEAREA_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getFileAreas, deleteFileArea, deleteSelectedFileAreas, getFileAreaById, createFileArea, updateFileArea}
